export const FAILED_TO_FETCH = "Failed to fetch";
export const FAILED_TO_FETCH_ERROR_MESSAGE_$ = `${FAILED_TO_FETCH} {0}`;
export const SOMETHING_WENT_WRONG = "Something went wrong";
export const IS_NOT_ALLOWED = "is not allowed";
export const SHOW_ALERT_DISPLAY_TIME = 10000; // 10000ms